export default "__VITE_ASSET__DTOQBZZJ__"